import { ModalContext } from 'app/app';
import axios from 'axios';
import { ViewContext } from 'components/lib';
import { useState } from 'react';
import { useEffect } from 'react';
import { useContext } from 'react';
import { Fragment } from 'react';
import { useParams } from 'react-router-dom';

const ticketIssue = [
  { value: '3 years loss runs' },
  { value: "MVR's for all drivers" },
  { value: 'Connect ELD/Camera' },
  { value: 'Insured Payment Needed' },
  { value: 'DOT Safety Manual' },
  { value: "Driver Count on SAFER Doesn't Match" },
  { value: "Units on SAFER Don't Match" },
  { value: 'Ineligible Cargo On SAFER' },
  { value: 'DOT Number Incorrect' },
  { value: 'Address On Policy different than SAFER' },
  { value: 'Detailed/Precise Items the insured is Hauling' },
  { value: 'Insured is linked to 1 or more other entities' },
  { value: 'Proof of Prior Ins Needed' },
  { value: 'Proof of Companion Policy Needed' },
  { value: 'Proof of Registration Needed' },
  { value: 'Bill of Sale or Lease Termination Document needed' },
  { value: 'Statement of No loss needed' },
  { value: 'Other' },
];

export default function AddTicketIssuesModal() {
  const { id } = useParams();
  const { modal, setModal } = useContext(ModalContext);
  const context = useContext(ViewContext);

  const [ticketData, setTicketData] = useState(null);
  const [selectedIssues, setSelectedIssues] = useState([]);

  async function fetchTicketData() {
    await axios
      .get(`/api/tickets/admin/${id}`)
      .then(async (res) => {
        const ticketResponseData = res.data.data;
        setTicketData(ticketResponseData);
        if (ticketResponseData && ticketResponseData.ticketIssues) {
          setSelectedIssues(ticketResponseData.ticketIssues);
        }
      })
      .catch((err) => {
        console.log(err);
        context.notification.show(
          'Something went wrong!',
          'error',
          true,
          'toast',
          'x-circle'
        );
        setModal('');
      });
  }

  useEffect(() => {
    if (id) {
      fetchTicketData();
    } else return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleIssueChange = (issue) => {
    setSelectedIssues((prevSelectedIssues) => {
      const issueObject = { value: issue };
      if (prevSelectedIssues.some((i) => i.value === issue)) {
        return prevSelectedIssues.filter((i) => i.value !== issue);
      } else {
        return [...prevSelectedIssues, issueObject];
      }
    });
  };

  const handleSaveClick = async () => {
    if (selectedIssues.length === 0) {
      context.notification.show(
        'Please select at least one issue before continuing.',
        'error',
        true,
        'toast',
        'x-circle'
      );
      return;
    } else {
      try {
        const updatedIssues = selectedIssues.map((issue) => {
          const existingIssue = ticketData.ticketIssues.find(
            (i) => i.value === issue.value
          );
          return existingIssue
            ? {
                ...existingIssue,
                solved: issue.solved || existingIssue.solved,
              }
            : issue;
        });

        const response = await axios.put(`/api/tickets/${id}`, {
          ticketIssues: updatedIssues,
        });

        if (response.status !== 200) {
          throw new Error('Failed to update ticket issue');
        }

        setTicketData((prevData) => ({
          ...prevData,
          ticketIssues: updatedIssues,
        }));

        context.notification.show(
          'Issues sent successfully!',
          'success',
          true,
          'toast',
          'check-circle'
        );

        setModal('');
        window.location.reload();
      } catch (error) {
        context.notification.show(
          'There was a problem when updating the issue.',
          'error',
          true,
          'toast',
          'x-circle'
        );
      }
    }
  };

  return (
    <Fragment>
      {modal.name === 'add_ticket_issue_modal' && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-[102] flex items-center justify-center">
          <div className="w-full max-w-[600px] bg-white flex items-center justify-center rounded-[12px]">
            <div className="w-[93%] mt-[20px] mb-[8px]">
              <div
                className="mb-6 1w-full mx-auto bg-white max-w-screen-xl"
                id="14"
              >
                <div className="p-4 pl-6 mt-4 pt-0">
                  Add new issues that need to be addressed:
                </div>

                <div className="flex-col border rounded p-4 pt-0 border-slate-300 mx-6">
                  {ticketIssue.map((issue, index) => (
                    <div
                      key={index}
                      className="flex justify-between py-2 border-b border-slate-300"
                    >
                      <div>{issue.value}</div>
                      <input
                        type="checkbox"
                        checked={selectedIssues.some(
                          (i) => i.value === issue.value
                        )}
                        onChange={() =>
                          handleIssueChange(issue.value)
                        }
                      />
                    </div>
                  ))}
                </div>

                <div className="p-4 mt-4 pt-0">
                  <div className="w-full flex items-center justify-end">
                    <button
                      className="h-12 px-4 bg-white border border-gray-400 font-semibold rounded-md cursor-pointer"
                      onClick={() => {
                        setModal('');
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="h-12 ml-2 px-4 bg-[#d32425] font-semibold rounded-md cursor-pointer text-white disabled:bg-gray-200 disabled:cursor-not-allowed"
                      onClick={handleSaveClick}
                      disabled={
                        modal.data.ticketStatus === 'Completed'
                      }
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
